import { get, post, put, del } from '../../actions/apiMethods';

const crud = (slug) => ({
  fetchAll: () => get(`mms/${slug}`),
  fetchById: (id) => get(`mms/${slug}/${id}`),
  create: (json) => post(`mms/${slug}`, json),
  update: (id, json) => put(`mms/${slug}/${id}`, json),
  remove: (id) => del(`mms/${slug}/${id}`),
  removeMultiple: (ids) => post(`mms/${slug}/delete`, { ids }),
});



export const interpolation = {
  fetch: ({ station_id, parameter_id, date_from, date_to }) => get(`qc/api/interpolation?station_id=${station_id}&parameter_id=${parameter_id}&date_from=${date_from}&date_to=${date_to}`),
  manualObservationUpdate: json => post('qc/api/interpolation/manual-update', json)
};




// WEBPACK FOOTER //
// ./src/components/Tools/api.js